// components/transaction-forms/DepositFormFields.js
import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { ErrorMessage } from "formik";
import { formatINR } from "../../helpers";

const DepositFormFields = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  accounts,
  selectedAccountBalance,
  handleAccountChange,
  t,
}) => {
  return (
    <>
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>{t("transaction.form.currentBalance")}</Form.Label>
            <Form.Control
              type="text"
              value={formatINR(selectedAccountBalance)}
              disabled
              className="bg-light"
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label className="required">
              {t("transaction.form.amount")}
            </Form.Label>
            <Form.Control
              type="number"
              name="amount"
              value={values.amount}
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={touched.amount && !!errors.amount}
              placeholder="0.00"
              step="0.01"
              min="0.01"
            />
            <ErrorMessage
              name="amount"
              component="div"
              className="text-danger small mt-1"
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={12}>
          <Form.Group>
            <Form.Label>{t("transaction.form.remarks")}</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="remarks"
              value={values.remarks}
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={touched.remarks && !!errors.remarks}
              placeholder={t("transaction.form.remarksPlaceholder")}
              maxLength={500}
            />
            <ErrorMessage
              name="remarks"
              component="div"
              className="text-danger small mt-1"
            />
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default DepositFormFields;
